import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/views/Dashboard';
import ServiceGroups from '@/views/ServiceGroups';
import ServiceGroup from '@/views/ServiceGroup';
import Scenes from '@/views/Scenes';
import LoggingView from '@/views/logging/LoggingView';
import LogChartView from '@/views/logging/LogChartView';
import LogTableView from '@/views/logging/LogTableView';
import LoggedItemsListView from '@/views/logging/LoggedItemsListView';
import Notifications from '@/views/Notifications';
import Settings from '@/views/Settings';
import Spaceplan from '@/views/Spaceplan';
import Spaceplans from '@/views/Spaceplans';
import UserSettings from '@/views/settings/User';
import PLCConnectionSettings from '@/views/settings/PLCConnectionSettings';
import UsersManagement from '@/views/settings/UsersManagement';
import Subscription from "@/views/settings/Subscription";
import ServiceDevices from '@/views/ServiceDevices';
import ErrorServices from '@/views/ErrorServices';
import UserPermissions from '@/views/settings/UserPermissions';
import UserAPIToken from '@/views/settings/UserAPIToken';
import Helpdesk from '@/views/Helpdesk';
import ChangeProject from '@/views/ChangeProject';
import Devices from '@/views/Devices';
import DumpAllServices from '@/views/DumpAllServices';
import GridPlay from '@/views/GridPlay';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        contextMenu: () => import('@/components/context-menus/DashboardCtxMenu'),
      },
    },
    {
      path: '/settings',
      component: Settings,
    },
    {
      path: '/settings-user',
      name: 'settings-user',
      component: UserSettings,
    },
    {
      path: '/plc-connection-settings',
      name: 'plc-connection-settings',
      component: PLCConnectionSettings,
    },
    {
      path: '/user-api-token-settings',
      name: 'user-api-token-settings',
      component: UserAPIToken,
    },
    {
      path: '/users-management',
      name: 'users-management',
      component: UsersManagement,
      meta: {
        contextMenu: () => import('@/components/context-menus/Users'),
      },
    },
    {
      path: '/subscription',
      name: 'subscription',
      component: Subscription,
    },
    {
      path: '/user-permissions/:id',
      name: 'user-permissions',
      component: UserPermissions,
      props(route) {
        const props = { ...route.params };
        props.id = +props.id;
        return props;
      },
      meta: {
        contextMenu: () => import('@/components/context-menus/UserPermissions'),
      },
    },
    {
      path: '/spaceplan/:id',
      name: 'spaceplan',
      component: Spaceplan,
      props(route) {
        const props = { ...route.params };
        props.id = +props.id;
        return props;
      },
      meta: {
        contextMenu: () => import('@/components/context-menus/Spaceplan'),
      },
    },
    {
      path: '/spaceplans',
      name: 'spaceplans',
      component: Spaceplans,
      meta: {
        contextMenu: () => import('@/components/context-menus/Spaceplans'),
      },
    },
    {
      path: '/place/:placeId/service-groups',
      name: 'service-groups',
      component: ServiceGroups,
      props(route) {
        const props = { ...route.params };
        props.placeId = +props.placeId;
        return props;
      },
      meta: {
        contextMenu: () => import('@/components/context-menus/ServiceGroups'),
      },
    },
    {
      path: '/place/:placeId/service-group/:serviceGroupId/services',
      name: 'service-group',
      component: ServiceGroup,
      props(route) {
        const props = { ...route.params };
        props.placeId = +props.placeId;
        props.serviceGroupId = +props.serviceGroupId;
        return props;
      },
      meta: {
        contextMenu: () => import('@/components/context-menus/Services'),
      },
    },
    {
      path: '/place/:placeId/service-group/:serviceGroupId/service/:serviceId',
      name: 'service-devices',
      component: ServiceDevices,
      props(route) {
        const props = { ...route.params };
        props.serviceId = +props.serviceId;
        props.placeId = +props.placeId;
        props.serviceGroupId = +props.serviceGroupId;
        return props;
      },
      meta: {
        contextMenu: () => import('@/components/context-menus/Services'),
      },
    },
    {
      path: '/devices',
      name: 'devices',
      component: Devices,
    },
    {
      path: '/scenes',
      name: 'scenes',
      component: Scenes,
      meta: {
        contextMenu: () => import('@/components/context-menus/Scenes'),
      },
    },
    {
      path: '/logging',
      name: 'logging-home',
      component: LoggingView,
      children: [
        {
          path: '',
          name: 'logging-default',
          component: LoggedItemsListView,
          meta: {
            contextMenu: () => import('@/components/context-menus/Logging'),
          },
        },
        {
          name: 'logging-visualization',
          path: 'visualization',
          component: LogChartView,
          props(route) {
            const props = { ...route.query };
            props.varsIds = props.vars;
            return props;
          },
          meta: {
            contextMenu: () => import('@/components/context-menus/Logging'),
          },
        },
        {
          name: 'logging-table',
          path: 'table',
          component: LogTableView,
          props(route) {
            const props = { ...route.query };
            props.varsIds = props.vars;
            return props;
          },
          meta: {
            contextMenu: () => import('@/components/context-menus/Logging'),
          },
        },
      ],
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Notifications,
    },
    {
      path: '/change-project',
      name: 'changeproject',
      component: ChangeProject,
      meta: {
        contextMenu: () => import('@/components/context-menus/ChangeProject'),
      },
    },
    {
      path: '/helpdesk',
      name: 'helpdesk',
      component: Helpdesk,
    },
    {
      path: '/error-services',
      name: 'error-services',
      component: ErrorServices,
    },
    {
      path: '/dumpallservices',
      name: 'dumpallservices',
      component: DumpAllServices,
    },
    {
      path: '/gridplay',
      name: 'gridplay',
      component: GridPlay,
    },
  ],
});
